import { formatZonedDateTimeRange } from "../../../lib/time";

export function formatFinalizedSessionTime({ start, end, timeZone }) {
  return formatZonedDateTimeRange({
    start,
    end,
    timeZone,
    startPattern: "EEE · MMM d, yyyy · h:mm a",
    showTimeZone: true,
  });
}
